import { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function HotGridSection() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const hotArticles = articles.filter((a) => a.isHot);

  const checkScroll = () => {
    if (!scrollRef.current) return;
    const el = scrollRef.current;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 10);
  };

  const scroll = (direction: 'left' | 'right') => {
    if (!scrollRef.current) return;
    const scrollAmount = 320;
    scrollRef.current.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    });
    setTimeout(checkScroll, 400);
  };

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              热搜爆料
            </h2>
            <p className="text-sm text-foreground-500 mt-1">今日最热吃瓜内容，实时追踪更新</p>
          </div>
          <div className="hidden sm:flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              disabled={!canScrollLeft}
              className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors cursor-pointer ${
                canScrollLeft ? 'bg-background-200 hover:bg-background-300 text-foreground-600' : 'bg-background-100 text-foreground-400 cursor-default'
              }`}
            >
              <i className="ri-arrow-left-s-line"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              disabled={!canScrollRight}
              className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors cursor-pointer ${
                canScrollRight ? 'bg-background-200 hover:bg-background-300 text-foreground-600' : 'bg-background-100 text-foreground-400 cursor-default'
              }`}
            >
              <i className="ri-arrow-right-s-line"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-4 overflow-x-auto scrollbar-hide pb-2"
          onScroll={checkScroll}
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {hotArticles.map((article) => (
            <div key={article.id} className="flex-shrink-0 w-[280px] md:w-[320px]">
              <ArticleCard article={article} />
            </div>
          ))}
        </div>

        <div className="mt-6 text-center">
          <Link
            to="/category/remen-tuijian"
            className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
          >
            查看全部热门
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}